import invariant from 'invariant'
import {
  NOTIFICATION_SUCCESS,
  NOTIFICATION_WARNING,
  NOTIFICATION_ERROR,
  NOTIFICATION_RESET,
  NOTIFICATION_CLICKED
} from 'actions/notifications/constants'
import { isFSA } from 'flux-standard-action'

let initialState = {
  bars: [], // notification bar
  notificationClicked: false
}
function reducer (state = initialState, action) {
  invariant(
    isFSA(action),
    `Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ${JSON.stringify(action)}`
  )

  const {payload = {}} = action
  let newBars = []
  state.bars.forEach((bar) => {
    newBars.push(bar)
  })

  switch (action.type) {
    case NOTIFICATION_SUCCESS:
      newBars.push({'level': 'success', 'message': payload.message})
      return {...state, bars: newBars}
    case NOTIFICATION_WARNING:
      newBars.push({'level': 'warning', 'message': payload.message})
      return {...state, bars: newBars}
    case NOTIFICATION_ERROR:
      newBars.push({'level': 'error', 'message': payload.message})
      return {...state, bars: newBars}
    case NOTIFICATION_RESET:
      return {...state, bars: []}
    case NOTIFICATION_CLICKED:
      return {...state, notificationClicked: payload.notificationClicked}
    default:
      return {...state}
  }
}

export {reducer}



// WEBPACK FOOTER //
// ./app/reducers/notifications.js